import { render } from "./warranty-activation.vue?vue&type=template&id=316f4b42&scoped=true"
import script from "./warranty-activation.vue?vue&type=script&lang=js"
export * from "./warranty-activation.vue?vue&type=script&lang=js"

import "./warranty-activation.vue?vue&type=style&index=0&id=316f4b42&lang=scss&scoped=true"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316f4b42"]])

export default __exports__